import React from 'react';

const textField = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	
	return (
		<input onKeyDown={props.keyDownHandler} onChange={props.changed} type="text" name={props.fieldKey} className={fieldDetail.classname} placeholder={fieldDetail.placeHolder} value={fieldDetail.value} disabled={fieldDetail.disabled} onBlur={props.onblur}/>
	);
}

export default textField;